<template>
    <button class="start-button">{{ label }}</button>
</template>

<script>
export default {
    props: [
        'label'
    ]
}
</script>

<style scoped>
.start-button {
    text-decoration: none;
    width: 100%;
    padding-top: 15px;
    padding-bottom: 15px;
    background: white;
    border-radius: 1000px;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #0B0918;
    font-size: 20px;
    font-family: Poppins, serif;
    font-weight: 600;
    word-wrap: break-word;
}
</style>